import { FC, Fragment } from "react";
import React from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { NumberInput } from "../core/NumberField";
import { useStyles } from "../../useStyles";
import { Switch } from "../core/Switch";
import { SaunaIcon } from "../core/icons/Icons";
import { BoxedInputWithIconAndOptionalSwitch } from "../core/BoxedInputWithIconAndOptionalSwitch";
import { InputLabel } from "@material-ui/core";

export const IncreaseExpectedElectricSaunaForm: FC = () => {
    const classes = useStyles();
    const { values, getFieldProps, setValues } =
        useFormModel<ChangeNames.INCREASE_EXPECTED_ELECTRIC_SAUNA>();
    return (
        <Fragment>
            <BoxedInputWithIconAndOptionalSwitch
                icon={<SaunaIcon />}
                content={
                        <p className={classes.label} style={{ marginBottom: 8 }}>
                            Sauna
                        </p>
                }
                useSwitch={
                    <Switch
                        checked={values.increaseExpectedElectricSauna.value.installed}
                        {...getFieldProps("increaseExpectedElectricSauna.value.installed")}
                        onChange={(e, checked) =>
                            setValues((values) => {
                                values.increaseExpectedElectricSauna.value.installed = checked;
                                values.increaseExpectedElectricSauna.value.demand.amount = checked
                                    ? 0
                                    : null;
                            })
                        }
                    />
                }
                detailCondition={values.increaseExpectedElectricSauna.value.installed}
                detail={
                    <Fragment>
                        <InputLabel className={classes.labledTextfieldLabel}>
                            Summe der Leistung
                        </InputLabel>
                        <NumberInput
                            className={classes.textField}
                            decimalScale={values.increaseExpectedElectricSauna.value.demand.precision}
                            allowLeadingZeros={false}
                            allowNegative={false}
                            thousandSeparator="."
                            decimalSeparator=","
                            adornment={values.increaseExpectedElectricSauna.value.demand.unit}
                            value={values.increaseExpectedElectricSauna.value.demand.amount || ""}
                            placeholder="0"
                            onValueChange={(v) =>
                                setValues((values) => {
                                    values.increaseExpectedElectricSauna.value.demand.amount =
                                        v.floatValue || null;
                                })
                            }
                            error={values.increaseExpectedElectricSauna.error != null}
                        />
                    </Fragment>
                }
            />
        </Fragment>
    );
};
